import { render, staticRenderFns } from "./ExpertCardTaiwan.vue?vue&type=template&id=2ce22952&scoped=true"
import script from "./ExpertCardTaiwan.vue?vue&type=script&lang=js"
export * from "./ExpertCardTaiwan.vue?vue&type=script&lang=js"
import style0 from "./ExpertCardTaiwan.vue?vue&type=style&index=0&id=2ce22952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce22952",
  null
  
)

export default component.exports